import { render, staticRenderFns } from "./WinningScientificCompetition.vue?vue&type=template&id=5415b022&scoped=true"
import script from "./WinningScientificCompetition.vue?vue&type=script&lang=js"
export * from "./WinningScientificCompetition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5415b022",
  null
  
)

export default component.exports